import React,{useState,useRef} from "react";
import "../../../Pages/Home/Sections/sections.scss";
import {useHistory} from "react-router-dom";
import {useBasket, useDispatchBasket} from "../../../hooks";
import {DeleteBasket} from "../../OnlineStore/OnlineStoreService";
import {AddBasket} from "../../../Components/OnlineAddress/OnlineAddressService";
import {Modal, Spin} from "antd";
import Shipping from "../../../Components/Shipping/Shipping";
import {sendPresRequest_api, sendPresRequestFile_api} from "../../../Services/apis";
import toaster from "toasted-notes";


function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}


function Success(props) {
    return(
        <div className="success_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}


function ActualItem({it,link}){
    const [loading,set_loading] = useState(false);
    const [currentItem,set_currentItem] = useState(null);
    const history = useHistory()
    const setBasket = useDispatchBasket();
    const basket = useBasket();
    const inputFileRef = useRef( null );


    const goTo = async(it)=>{
        if(it.link_to!=="mall_parking")
            return link(it.link_to,it)

        let token = localStorage.getItem("token")
        if(token)
            showModal(it)
        else
            history.push("/login")

    }

    // const basketProccess = async()=>{
    //     set_loading(true);
    //     let merchantId = it.link_to_uid.split("/")[0]
    //     let product = {uid:it.link_to_uid.split("/")[1]}
    //
    //
    //
    //     //Clear Basket
    //     localStorage.removeItem("basket");
    //     await DeleteBasket()
    //     setBasket([])
    //
    //     //Add Product Uid To Basket
    //     await AddBasket(merchantId,product.uid);
    //     setBasket(oldArray => [...oldArray, {product:product,count:1}]);
    //     localStorage.setItem("basket",JSON.stringify([...basket, {product:product,count:1}]));
    //
    //     set_loading(false)
    //     //Add State Clinic To route And Redirect to online-store-basket/MerchantId
    //     history.push(`online-store-basket/${merchantId}`,{state:"clinic"});
    // }

//--------------------------------------------------------------------- Start Prescription ----------------------------------------------------------
    const showModal = (it) => {
        set_currentItem(it)
        set_visible(true);

    };

    const handleOk = () => {
        set_visible(false);
    };

    const handleCancel = (e) => {
        e.stopPropagation();
        set_visible(false);
    };

    const [visible,set_visible] = useState(false);
    const [file,set_file] = useState({});

    const onFileChange = ( e ) => {
        console.log( e.target.files );
        if(e.target.files.length > 0){
            set_file(e.target.files[0])
        }
    }
    const onBtnClick = () => {
        inputFileRef.current.click();
    }

    const [national_code,set_national_code] = useState("")
    const [prescription_id,set_prescription_id] = useState("")
    const [description,set_description] = useState("")


    const sendPresRequest = async ()=>{
        const formData = new FormData();
        formData.append('file_1', file);
        formData.append('national_code', national_code);
        formData.append('prescription_id', prescription_id);
        formData.append('description', description);
        set_loading(true);
        let merchantId = it.link_to_uid.split("/")[0]
        let product = {uid:it.link_to_uid.split("/")[1]}
        try{
            const res = await sendPresRequestFile_api(formData,merchantId)
            set_loading(false);
            toaster.notify(({ onClose }) => (<Success   message={"درخواست شما با موفقیت ارسال شد"}/>),{duration: 2000});
            set_visible(false);
        }catch(e){
            set_loading(false);
            console.error(e);
            toaster.notify(({ onClose }) => (<Error   message={"مشکل در ارسال اطلاعات"}/>),{duration: 2000});
        }
    }


    //--------------------------------------------------------------------- End Prescription ----------------------------------------------------------

    return(
        <div className="actual-item actual-desktop-item" onClick={e=>goTo(it)}>
            <img src={it.image_desktop} alt=""/>

            <Modal visible={visible} footer={null} onOk={handleOk} onCancel={handleCancel}   closable={false} bodyStyle={{padding:0}}>
                <div className="booking-header">
                    <span>ثبت نسخه</span>
                </div>

                <Spin spinning={loading}>
                <div className="booking-form">
                    <br/>
                    <div className="booking-form-item">
                        <input
                            value={national_code}
                            onChange={e=>set_national_code(e.target.value)}
                            type="text" name="" id="" placeholder="کد ملی"/>
                    </div>

                    <div className="booking-form-item">
                        <input
                            value={prescription_id}
                            onChange={e=>set_prescription_id(e.target.value)}
                            type="text" name="" id="" placeholder="کد رهگیری"/>
                    </div>

                    {/*<div className="booking-form-item">*/}
                    {/*    <select name="" id="">*/}
                    {/*        <option value="">بیمه تامین اجتماعی</option>*/}
                    {/*        <option value="">بیمه خدمات درمانی</option>*/}
                    {/*        <option value="">بیمه آزاد</option>*/}
                    {/*    </select>*/}
                    {/*</div>*/}
                    <div className="booking-form-item">
                    <textarea
                        placeholder="توضیحات"
                        value={description}
                        onChange={e=>set_description(e.target.value)}
                        name="" id="" cols="30" rows="3">
                    </textarea>
                    </div>

                    <div className="booking-form-item">
                        <span className="booking-upload-btn" onClick={onBtnClick}>{file && file.name?file.name:" آپلود تصویر نسخه "}</span>
                    </div>

                </div>


                <br/>
                <div className="booking-foot">
                    <span className="booking-submit-btn" onClick={sendPresRequest}>ثبت نسخه</span>
                    <input
                        ref={inputFileRef}
                        onChange={onFileChange}
                        type="file" name="" id="" placeholder="تصویر نسخه"/>
                </div>
                </Spin>
            </Modal>
        </div>
    )
}



function ActualDesktop({item,link}){



    return(
        <div style={{margin: "20px 16px 0 16px"}}>
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <div key={item.items[0].uid} className="actual-bar" >
                <div className="actual-sec">
                    {item.items?.map(it=>{
                        return(
                            <ActualItem  it={it} link={link}/>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default ActualDesktop
